import React, { useEffect, useMemo } from 'react';
import { observer } from 'mobx-react-lite';
import { StatisticsIntervalTypeEnum } from '@app/common';
import { STATISTIC_INTERVALS } from '../../../models/stores/statistic/statistic-store';
import { useRootStore } from '../../../providers/root-store-provider';
import { PeriodSwitcher } from './period-switcher';

export const PROFIT_CHART_EXCLUDED_PERIOD_TYPES: StatisticsIntervalTypeEnum[] = [StatisticsIntervalTypeEnum.Today];

type ProfitPeriodSwitcherProps = {
    loading?: boolean;
};

export const ProfitPeriodSwitcher: React.FC<ProfitPeriodSwitcherProps> = observer(({ loading }) => {
    const { statisticStore } = useRootStore();
    const intervals = useMemo(() => {
        return STATISTIC_INTERVALS.filter((period) => !PROFIT_CHART_EXCLUDED_PERIOD_TYPES.includes(period.type));
    }, []);
    const selectedType = intervals.some((period) => period.type === statisticStore.type)
        ? statisticStore.type
        : intervals[0]?.type ?? statisticStore.type;

    useEffect(() => {
        if (loading || intervals.length === 0 || selectedType === statisticStore.type) {
            return;
        }

        statisticStore.setType(selectedType).catch(() => undefined);
    }, [intervals.length, loading, selectedType, statisticStore, statisticStore.type]);

    return (
        <PeriodSwitcher
            value={selectedType}
            onChange={(periodType) => statisticStore.setType(periodType)}
            excludedTypes={PROFIT_CHART_EXCLUDED_PERIOD_TYPES}
            loading={loading}
        />
    );
});
